import { ActionIcon, Box, Divider, Grid, Group, Paper, Text, UnstyledButton } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/auth.context';
import { useLanguage } from '../contexts/language.context';
import ProfilePage from './profile';
import UsersPage from './users';
import ModelsPage from './models';
import { FaPlus } from 'react-icons/fa6';
import PlansPage from './plans';
// import { Channels, Flows } from '../components';

export default function SettingsPage(){
    const {role, planData} = useAuth();
    const {str} = useLanguage();

    const isMobile = useMediaQuery('(max-width: 900px)');

    const [selected, setSelected] = React.useState(isMobile ? null : "profile");
    const [openUsers, setOpenUsers] = React.useState(false);

    const { hash } = useLocation();
    const navigate = useNavigate();

    const options = [
        {key: "profile", title: str("PROFILE.TITLE") },
        {key: "users", title: "Usuários", buttons: [
            { leftSection: <FaPlus />, title: "Usuário", onClick: () => {setOpenUsers(true)} }
        ]},
        {key: "models", title: "Marcas e Modelos" },
        {key: "plans", title: "Planos" },
        // role && {key: "teams", title: "Equipes", buttons: [
        //     { leftSection: <FaPlus />, title: "Equipe", onClick: () => {setOpenTeams(true)} }
        // ]},
        // role && {key: "financeiro", title: "Financeiro" },
    ].filter(nn => nn)

    React.useEffect(() => {
        if (hash) {
            setSelected(hash.split("#")[1]);
        }else{
            setSelected(isMobile ? null : "profile");
        };
      }, [hash, isMobile]);
    
    React.useEffect(() => {
        if (selected && !options.find(opt => opt.key === selected)) {
            setSelected("profile");
        }
    }, [selected, isMobile]);

    return <>
        <Paper shadow='xs' style={{padding: 0}}>
            <Grid gutter={0}>
                {(!isMobile || !selected) && <Grid.Col span={{ base: 12, md: 4 }} style={{minHeight: '70vh'}}>
                    <Box style={{height: '100%'}}>
                        {options.map(({ key, title }) => (
                            <UnstyledButton style={{width: '100%'}} onClick={() => {
                                // if(!allowed) notifications.show({
                                //     title: "Payment required",
                                //     message: "Check for your billing settings, there is one payment subscription that failed, change your payment method and try again.",
                                //     color: "yellow"
                                // })
                                navigate(`/configuracoes#${key}`);
                            }}>
                                <Group
                                    style={{borderRight: `7px solid ${selected === key ? "black" : "transparent"}`}}
                                    p="xl"
                                >
                                    <Box style={{flex: 1}}>
                                        <Text size="md" fw="bold">{title}</Text>
                                    </Box>
                                </Group>
                                <Divider />
                            </UnstyledButton>
                        ))}
                    </Box>
                </Grid.Col>}
                {(!isMobile || selected) && <Grid.Col span={{ base: 12, md: 8 }} style={{minHeight: '70vh', backgroundColor: '#F2F2F2'}}>
                    {isMobile && <Group p="md">
                        <ActionIcon size="xl" onClick={() => navigate("/settings")}><FaArrowLeft /></ActionIcon>
                    </Group>}
                    <Box p="md" pr="xl">
                        {selected === "profile" && <ProfilePage />}
                        {selected === "brand" && <ProfilePage company />}
                        {selected === "users" && <UsersPage />}
                        {selected === "models" && <ModelsPage />}
                        {selected === "plans" && <PlansPage />}
                    </Box>
                </Grid.Col>}
            </Grid>
            </Paper>

    </>
    
}
